import React from 'react';
import OwnerLayout from '../../components/OwnerLayout';
import { AuditLog } from '../../components/owner/SystemTools';

export default function OwnerActivityPage() {
  return <OwnerLayout><div className="owner-page-heading"><div><p className="owner-eyebrow">SYSTEM</p><h1 data-testid="owner-activity-heading">Activity log</h1></div></div><AuditLog /></OwnerLayout>;
}